var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TotemLink',{staticClass:"digital-classrooms-event__button-teams",attrs:{"color":"teams-blue","size":"medium","label":_vm.$t('DigitalClassrooms.join_teams_meeting'),"target":"_blank","href":_vm.meetingUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }